export default "__VITE_ASSET__30c9dfd1__"